import React from 'react';

/**
 * Calculate and show the Collection Pack Status of an order
 *
 * @param props.order The Gear Order
 */
export default function CollectionPackStatus({ order, trackingString }) {
	const statusText = getCollectionPackStatus(order);
	let statusDate = getStatusDate(order);

	let colorClass = 'text-warning';
	if (statusText?.startsWith(CollectionPackStatuses.SHIPPED)) {
		colorClass = 'text-info';
	} else if (statusText === CollectionPackStatuses.ACCESSIONED) {
		colorClass = 'text-success';
	}

	return (
		// marginLeft 80 to align the status under the product name
		<caption style={{ captionSide: 'bottom', padding: '0', marginLeft: '115px' }}>
			<em className={colorClass}>
				{(statusText?.startsWith(CollectionPackStatuses.SHIPPED) || statusText?.startsWith(CollectionPackStatuses.DELIVERED)) && trackingString !== "" ?
						<a href={"https://www.fedex.com/fedextrack/?action=track&tracknumbers="+trackingString} target="_blank" rel="noopener noreferrer">
							<strong>{statusText}</strong> <span style={{fontSize: "12px", fontStyle: "italic"}}>({statusDate})</span> <span className="fa fa-external-link pr-5"></span>
						</a>
						:
						<strong>{statusText}</strong>
				}
			</em>
		</caption>
	);
}

/**
 * Grabs the correct date for the shipping step
 */
const getStatusDate = (order) => {
	return (order.trackingInformation?.deliveryDate ? order.trackingInformation?.deliveryDate : order.trackingInformation?.shippingDate);
}

/**
 * Gets the Collection Pack status of an order
 */
const getCollectionPackStatus = (order) => {
	if ((!order?.gearOrderId && !order.requisitions?.length) || !order.requisitions?.length) {
		return null;
	}

	const isDropShip = order.requisitions.filter((req) => req.patientDropship).length > 0;
	const isShipToOffice = !isDropShip && order.requisitions.filter((req) => req.shipToOffice).length > 0;
	const isActivation = !isDropShip && !isShipToOffice;
	const accessionedReqs = order.requisitions.filter((req) => req.accessionNo);

	if (accessionedReqs.length > 0 && accessionedReqs.length === order.requisitions.length) {
		// All requisitions on the order have been accessioned but not all have been released
		// Status 3, 4, or 9 are 'Released'
		const reqsNoteYetReleased = accessionedReqs.filter(
			(req) => req.accessionStatus !== 3 && req.accessionStatus !== 4 && req.accessionStatus !== 9
		);
		if (reqsNoteYetReleased.length) {
			return CollectionPackStatuses.ACCESSIONED;
		}

		// All reports are released
		return null;
	} else if (!order.workflow?.practitionerConfirmed && order.gearOrderId) {
		return null;
	} else if (order.packingSlipCanceled) {
		return null;
	} else if (!isActivation) {
		const recipient = isDropShip ? 'Patient' : 'Office';
		if (order.trackingInformation?.deliveryDate) {
			return `${CollectionPackStatuses.DELIVERED} to ${recipient}`;
		} else if (order.trackingInformation?.shippingDate) {
			return `${CollectionPackStatuses.SHIPPED} to ${recipient}`;
		} else {
			return CollectionPackStatuses.PROCESSING;
		}
	}

	return null;
};

export const CollectionPackStatuses = {
	ANY: 'Any',
	PROCESSING: 'Preparing Shipment', // A Drop-Ship or Ship-to-Office order has been placed but has not shipped yet
	SHIPPED: 'Shipped', // there is tracking information available for the order
	DELIVERED: 'Delivered', // order's packing slip was delivered
	ACCESSIONED: 'Received by Lab' // The Collection pack has been scanned by the lab
};
